module.exports = __webpack_public_path__ + "media/images/payments/stripe_trial_start-d99aa058b5a51105c070e4567426082a.png";